import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { PageTitleService } from '../../../../Utils/_services/page-title/page-title.service';
import { AccountService } from '../../../../Utils/_services/account/account.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CommonModule, AsyncPipe } from '@angular/common';
import { ICurrentUser } from '../../../../Utils/_services/account/account.model';
import { ThemeService } from '../../../../Utils/_services/theme/theme.service';

@Component({
  selector: 'user-header',
  standalone: true,
  imports: [CommonModule, AsyncPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  currentUser$: Observable<ICurrentUser | null>;
  pageTitle = 'User Panel';

  constructor(
    private pageTitleService: PageTitleService,
    private accountService: AccountService,
    private router: Router,
    private toastr: ToastrService,
    public themeService: ThemeService
  ) {
    this.currentUser$ = this.accountService.currentUser$;
  }

  onToggleClick() {
    this.toggleSidebar.emit();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.pageTitleService.title$.subscribe(title => {
      this.pageTitle = title;
    });

    // User session is now automatically initialized in AccountService constructor
  }

  goHome() {
    this.router.navigate(['/']);
  }

  logout() {
    this.accountService.logout();
    this.toastr.success('Logged out successfully!');
    this.router.navigate(['/auth/login']);
  }
}
